'use strict';

import execute_on from "../../../libs/execute-on";
import {swalWarningFire} from "../../../plugins/sweet-alert/sweet-alert-default";

execute_on('panel.transaction.get-invoice-details', function() {
    $(".selectInvoiceDetailsList").on('change', function () {
        const selectedInvoiceDetailsId = $(this).val();
        const invoiceDetailsData = $(this).data('invoice-details');
        const selectedInvoiceDetailsData = invoiceDetailsData[selectedInvoiceDetailsId]

        const $invoiceDetailBuyerSpan = $(".companyInvoiceDetails .invoiceDetailBuyer span");
        const $invoiceDetailFirstNameSpan = $(".companyInvoiceDetails .invoiceDetailFirstName span");
        const $invoiceDetailLastNameSpan = $(".companyInvoiceDetails .invoiceDetailLastName span");
        const $invoiceDetailAddressSpan = $(".companyInvoiceDetails .invoiceDetailAddress span");
        const $invoiceDetailPostalCodeSpan = $(".companyInvoiceDetails .invoiceDetailPostalCode span");
        const $invoiceDetailCitySpan = $(".companyInvoiceDetails .invoiceDetailCity span");
        const $invoiceDetailCountrySpan = $(".companyInvoiceDetails .invoiceDetailCountry span");
        const $invoiceDetailTaxSpan = $(".companyInvoiceDetails .invoiceDetailTax span");
        const $invoiceDetailContactNameSpan = $(".companyInvoiceDetails .invoiceDetailContactName span");
        const $invoiceDetailSendInvoiceToSpan = $(".companyInvoiceDetails .invoiceDetailSendInvoiceTo span");
        const $invoiceDetailAdditionalInfo = $(".invoiceAdditionalInfo");

        if (selectedInvoiceDetailsData) {
            $invoiceDetailBuyerSpan.text(selectedInvoiceDetailsData.buyer_name);
            $invoiceDetailAddressSpan.text(selectedInvoiceDetailsData.address);
            $invoiceDetailPostalCodeSpan.text(selectedInvoiceDetailsData.postal_code);
            $invoiceDetailCitySpan.text(selectedInvoiceDetailsData.city);
            $invoiceDetailCountrySpan.text(selectedInvoiceDetailsData.country.name);
            $invoiceDetailTaxSpan.text(selectedInvoiceDetailsData.tax_number);
            $invoiceDetailContactNameSpan.text(selectedInvoiceDetailsData.contact_name);
            $invoiceDetailSendInvoiceToSpan.text(selectedInvoiceDetailsData.additional_email);
            $invoiceDetailAdditionalInfo.val(selectedInvoiceDetailsData.additional_info);

            return;
        }

        $invoiceDetailBuyerSpan.text('');
        $invoiceDetailFirstNameSpan.text('');
        $invoiceDetailLastNameSpan.text('');
        $invoiceDetailAddressSpan.text('');
        $invoiceDetailPostalCodeSpan.text('');
        $invoiceDetailCitySpan.text('');
        $invoiceDetailCountrySpan.text('');
        $invoiceDetailTaxSpan.text('');
        $invoiceDetailContactNameSpan.text('');
        $invoiceDetailSendInvoiceToSpan.text('');
        $invoiceDetailAdditionalInfo.val('');
    });

    $(".showInvoicePreview").on('click', function (event) {
        event.preventDefault();

        const selectInvoiceDetailsVal = $(".selectInvoiceDetailsList").val();

        if ('' === selectInvoiceDetailsVal) {
            swalWarningFire({
                title: "The invoice details is required"
            });
            return;
        }

        $(".showInvoicePreviewForm .invoicePreviewDetailId").val(selectInvoiceDetailsVal);

        const invoiceAdditionalInfoVal = $(".invoiceAdditionalInfo").val();
        $(".showInvoicePreviewForm .invoicePreviewAdditionalInfo").val(invoiceAdditionalInfoVal);

        const invoicePaymentMethodVal = $(".invoicePaymentMethod").val();
        $(".showInvoicePreviewForm .invoicePreviewPaymentMethod").val(invoicePaymentMethodVal);

        $(".showInvoicePreviewForm").submit();
    });
});
